// import React, { useContext } from 'react';
// import { LayoutContext } from './context/layoutcontext';

const AppFooter = () => {
  // const { layoutConfig } = useContext(LayoutContext);

  return <div className="layout-footer"></div>;
};

export default AppFooter;
